import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { AsideDefault } from './components/aside/AsideDefault'
import { Footer } from './components/Footer'
import { HeaderWrapper } from './components/header/HeaderWrapper'
import { Toolbar } from './components/toolbar/Toolbar'
import { ScrollTop } from './components/ScrollTop'
import { Content } from './components/Content'
import { PageDataProvider } from './core'
import { useLocation } from 'react-router-dom'
// import {ThemeModeProvider} from '../partials'
import { MenuComponent } from '../assets/ts/components'

const MasterLayout = () => {
  const location = useLocation()
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])
  const [sidebarOpen, setSidebarOpen] = useState(false)
  return (
    <PageDataProvider>
      {/* <ThemeModeProvider> */}
      <div className='flex flex-row h-screen w-screen'>
        <AsideDefault
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          className='fixed top-0 left-0 h-screen w-[250px] z-40 hidden lg:block'
        />
        <div className='flex flex-col flex-1 lg:pl-[250px]' id='kt_wrapper'>
          <HeaderWrapper onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
          <div id='kt_content' className='flex flex-col flex-1'>
            <Toolbar />
            <div className='flex-1 flex' id='kt_post'>
              <Content>
                <Outlet />
              </Content>
            </div>
          </div>
          <Footer />
        </div>
      </div>
      <ScrollTop />
      {/* </ThemeModeProvider> */}
    </PageDataProvider>
  )
}

export { MasterLayout }
